import { Button, styled } from "@mui/material";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { IAppState } from "../../../store/app-state";
import colors from "../../../theme/themeConstants";
import SelectTags from "../SelectTags";
import UploadMoveBack from "../UploadMoveBack";
import UploadSearch from "../UploadSearch";
import { UploadContainer } from "./UploadFirstStep";
import { metrics } from "../../../utils/metrics";

interface IProps {
  next: () => void;
  back: () => void;
  publish: () => void;
  setTags: (tags: any) => void;
  selectedTags: string[];
  isUserVerified: boolean | undefined;
  isFetching: boolean;
  progressPercent: number;
  fileType: string | null;
}

const MIN_TAGS = 3;
const MAX_TAGS = 10;

const UploadFourthStep = (props: IProps) => {
  const {
    next,
    back,
    setTags,
    selectedTags,
  } = props;

  const tags = useSelector((state: IAppState) => state.tags.tags);

  const [filteredTags, setFilteredTags] = useState<any>(tags);

  const search = (value: string) => {
    if (value) {
      const newTags = tags.filter((el: any) => el.name.toLowerCase().includes(value.toLowerCase()));
      setFilteredTags(newTags);
    } else {
      setFilteredTags(tags);
    }
  };

  const handleNext = useCallback(async () => {
    await metrics.sendUploadTagsSelected();
    next();
  }, [next]);

  const btnState = !selectedTags ||
    selectedTags?.length < MIN_TAGS ||
    selectedTags?.length > MAX_TAGS;

  return (
    <UploadContainer sx={{ "& svg": { color: "white" } }}>
      <UploadMoveBack back={back} text={"Define Tags"}/>
      <StyledText>Choose 3-10 tags that match your video</StyledText>
      <UploadSearch onSearch={search}/>
      <TagsWrapper>
        <SelectTags tags={filteredTags} setTags={setTags} mainSelectedTags={selectedTags}/>
      </TagsWrapper>
      <ButtonContainer>
        <Button variant="contained" fullWidth sx={{
          background: colors.purpleGradient,
          minHeight: "3rem",
          fontSize: "16px",
          fontWeight: "500",
          borderRadius: "38px",
          marginTop: "24px",
          fontFamily: "Poppins",
          "@media screen and (max-width: 950px)": {
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
            zIndex: 100
          }
        }} onClick={handleNext} disabled={!!btnState}>
          Next
        </Button>
        {selectedTags?.length > MAX_TAGS && <p>Please choose a maximum of 10 tags!</p>}
      </ButtonContainer>
    </UploadContainer>
  );
};

export default UploadFourthStep;

const StyledText = styled("p")({
  marginTop: "2rem",
  marginBottom: "1rem",
  fontWeight: 500,
  fontSize: "16px",
  opacity: 0.8,
  textAlign: "left"
});

const TagsWrapper = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  marginTop: "24px",
  overflowY: "auto",
  maxHeight: "330px",
  overflowX: "hidden",
  "::-webkit-scrollbar": {
    display: "none",
  },
  "@media screen and (max-width: 767px)": {
    flexWrap: "nowrap",
    flexDirection: "column",
    maxHeight: "unset"
  }
});

const ButtonContainer = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  "p": {
    marginTop: "16px",
    color: "var(--red-accent)",
    fontWeight: 400,
    textAlign: "center",
  },
  "@media screen and (max-width: 950px)": {
    paddingTop: "0.5rem",
    background: "rgba(11, 11, 40, .7)",
  }
});
